var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgRecruitStep1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.482,
    height: 20.566,
    viewBox: "0 0 17.482 20.566",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.686,16.686H85.368v3.771h.686V17.371H86.4v3.085h.686V17.028a.343.343,0,0,0-.343-.343h-.686v-.343A.343.343,0,0,0,85.711,16H72.343a.343.343,0,0,0-.343.343v6.17h.686Z",
    transform: "translate(-72 -16)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.686,184H72v12.34a.343.343,0,0,0,.343.343H84V196H72.686Z",
    transform: "translate(-72 -176.802)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.142,53.827a.343.343,0,0,0,.343-.343V48.343a.343.343,0,0,0-.343-.343h-4.8a.343.343,0,0,0-.343.343v5.142a.343.343,0,0,0,.343.343Zm-4.456-5.142H108.8v4.456h-4.113Z",
    transform: "translate(-102.629 -46.629)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M248,128h5.142v.686H248Z",
    transform: "translate(-240.459 -123.201)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M248,168h5.142v.686H248Z",
    transform: "translate(-240.459 -161.487)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M104,208h3.428v.686H104Z",
    transform: "translate(-102.629 -199.773)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M200,208h5.484v.686H200Z",
    transform: "translate(-194.516 -199.773)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104,248h7.541v.686H104Z",
    transform: "translate(-102.629 -238.06)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M104,288h3.428v.686H104Z",
    transform: "translate(-102.629 -276.346)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M200,288h4.113v.686H200Z",
    transform: "translate(-194.516 -276.346)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M296,328h1.028v.686H296Z",
    transform: "translate(-286.402 -314.632)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M104,328h7.541v.686H104Z",
    transform: "translate(-102.629 -314.632)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M253.142,48.343A.343.343,0,0,0,252.8,48h-4.456a.343.343,0,0,0-.343.343v1.714a.343.343,0,0,0,.343.343H252.8a.343.343,0,0,0,.343-.343Zm-.686,1.371h-3.771V48.686h3.771Z",
    transform: "translate(-240.459 -46.629)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M104,369.714A1.714,1.714,0,1,0,105.714,368,1.714,1.714,0,0,0,104,369.714Zm2.742,0a1.028,1.028,0,1,1-1.028-1.028A1.028,1.028,0,0,1,106.742,369.714Z",
    transform: "translate(-102.629 -352.918)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M200,369.714A1.714,1.714,0,1,0,201.714,368,1.714,1.714,0,0,0,200,369.714Zm2.742,0a1.028,1.028,0,1,1-1.028-1.028A1.028,1.028,0,0,1,202.742,369.714Z",
    transform: "translate(-194.516 -352.918)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M303.865,142.4l-1.764-5.291A1.626,1.626,0,0,0,300.557,136h-.445a.343.343,0,0,0-.343.343v5.142h-.178l-.2-.247a2.057,2.057,0,0,0-2.891-.321l-.376.3a.343.343,0,0,0-.06.473l3.016,4.022v5.37a.343.343,0,0,0,.343.343h3.085a.343.343,0,0,0,.343-.343V148h-.686v2.742h-2.4V145.6a.343.343,0,0,0-.069-.206l-2.886-3.848.116-.093a1.371,1.371,0,0,1,1.927.214l.3.376a.343.343,0,0,0,.268.129h.686a.343.343,0,0,0,.343-.343v-5.142h.1a.942.942,0,0,1,.894.645l1.746,5.238v.568l-1.007,2.684a.343.343,0,0,0-.022.12v1.371h.686V146l1.007-2.684a.343.343,0,0,0,.022-.12v-.686a.343.343,0,0,0-.018-.108Z",
    transform: "translate(-286.401 -130.858)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M296,384h2.742v.686H296Z",
    transform: "translate(-286.402 -368.232)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M296,416h.686v.686H296Z",
    transform: "translate(-286.402 -398.861)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M328,416h1.371v.686H328Z",
    transform: "translate(-317.031 -398.861)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitStep1);
export default __webpack_public_path__ + "static/media/recruit-step1.a45fb428f82524f2f5b793fa5275f97c.svg";
export { ForwardRef as ReactComponent };